module.exports = __webpack_public_path__ + "img/sup_cardsetting_bank1.8a6a643c.jpg";